(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[725],{

/***/ 24089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ by_page_paginator; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/icons/nav-arrow.svg.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var NavArrow = function(_param) {
    var props = _extends({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16.507",
        height: "9.148",
        viewBox: "0 0 16.507 9.148",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Arrow_next",
            "data-name": "Arrow next",
            d: "M12.091,9.148l4.416-4.613L11.986,0H9.709l3.526,3.677H0l1.87,1.8H13.234L9.709,9.148Z",
            transform: "translate(0 0)"
        })
    });
};


// EXTERNAL MODULE: ./src/utils/_enums/button-variants.enum.tsx
var button_variants_enum = __webpack_require__(92212);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/_shared/by-page-paginator/by-page-paginator.module.scss
var by_page_paginator_module = __webpack_require__(30407);
var by_page_paginator_module_default = /*#__PURE__*/__webpack_require__.n(by_page_paginator_module);
;// CONCATENATED MODULE: ./src/components/_shared/by-page-paginator/by-page-paginator.tsx






var ByPagePaginator = function(props) {
    var updatePageNumber = function(newNumber) {
        if (props.setPageSettingsUpdate && newNumber >= 0 && newNumber !== props.pageNumber && newNumber <= props.lastPage) {
            props.setPageSettingsUpdate(newNumber, props.pageSize);
        }
    };
    var createPageNavigation = function() {
        var _loop = function(i) {
            if (i === 0 || i === variableCenterElement || i === lastPage) {
                if (lastPage > 1 && i === lastPage && variableCenterElement <= lastPage - 2) {
                    renderNavBar.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat((by_page_paginator_module_default()).separator),
                        children: "..."
                    }));
                }
                if (pageNumber === i) {
                    renderNavBar.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat((by_page_paginator_module_default()).current),
                        onClick: function() {
                            return updatePageNumber(i);
                        },
                        children: i + 1
                    }, i));
                } else {
                    renderNavBar.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat((by_page_paginator_module_default())["page-item"]),
                        onClick: function() {
                            return updatePageNumber(i);
                        },
                        children: i + 1
                    }, i));
                }
                if (i === 0 && variableCenterElement > 1) {
                    renderNavBar.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat((by_page_paginator_module_default()).separator),
                        children: "..."
                    }));
                }
            }
        };
        var pageNumber = props.pageNumber, lastPage = props.lastPage;
        var renderNavBar = [];
        var variableCenterElement = -1;
        if (lastPage >= 2) variableCenterElement = Math.floor(lastPage / 2);
        if (pageNumber !== 0 && pageNumber !== lastPage) variableCenterElement = pageNumber;
        for(var i = 0; i <= lastPage; i++)_loop(i);
        return renderNavBar;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (by_page_paginator_module_default())["by-page-paginator"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (by_page_paginator_module_default()).previous,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                    variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                    onClick: function() {
                        updatePageNumber(props.pageNumber - 1);
                    },
                    disabled: props.prevButtonDisabled,
                    icon: {
                        element: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavArrow, {}),
                        align: "right"
                    }
                })
            }),
            createPageNavigation(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (by_page_paginator_module_default()).next,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                    variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                    onClick: function() {
                        return updatePageNumber(props.pageNumber + 1);
                    },
                    disabled: props.nextButtonDisabled,
                    icon: {
                        element: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavArrow, {}),
                        align: "right"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var by_page_paginator = (ByPagePaginator);


/***/ }),

/***/ 10725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ teaser; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-swipeable/dist/react-swipeable.umd.js
var react_swipeable_umd = __webpack_require__(86037);
// EXTERNAL MODULE: ./src/utils/_enums/basic-card-variants.enum.ts
var basic_card_variants_enum = __webpack_require__(90017);
// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/utils/_helper/smooth-scrolling-helper.ts
var smooth_scrolling_helper = __webpack_require__(53827);
// EXTERNAL MODULE: ./src/utils/_hooks/useWindowSize.hook.ts
var useWindowSize_hook = __webpack_require__(29486);
// EXTERNAL MODULE: ./src/components/_shared/by-page-paginator/by-page-paginator.tsx + 1 modules
var by_page_paginator = __webpack_require__(24089);
// EXTERNAL MODULE: ./src/components/_shared/error/error-message.tsx
var error_message = __webpack_require__(63879);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./src/utils/_enums/button-variants.enum.tsx
var button_variants_enum = __webpack_require__(92212);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/_shared/teaser-buttons/teaser-buttons.module.scss
var teaser_buttons_module = __webpack_require__(27373);
var teaser_buttons_module_default = /*#__PURE__*/__webpack_require__.n(teaser_buttons_module);
;// CONCATENATED MODULE: ./src/components/_shared/teaser-buttons/teaser-buttons.tsx






var TeaserButtons = function(props) {
    var ref = (0,react.useState)(), lastClick = ref[0], setLastClick = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (teaser_buttons_module_default())["nav-buttons"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (teaser_buttons_module_default()).next,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                    variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_FILLED */.l.SECONDARY_FILLED,
                    onClick: function() {
                        setLastClick("NEXT");
                        props.onClickNext();
                    },
                    inverted: props.inverted,
                    disabled: props.nextButtonDisabled || lastClick === "PREV" && props.pending,
                    pending: lastClick === "NEXT" ? props.pending : false,
                    icon: {
                        element: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: [
                                "far",
                                "long-arrow-alt-right"
                            ]
                        }),
                        align: "right"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (teaser_buttons_module_default()).previous,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                    variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                    onClick: function() {
                        setLastClick("PREV");
                        props.onClickPrev();
                    },
                    inverted: props.inverted,
                    disabled: props.prevButtonDisabled || lastClick === "NEXT" && props.pending,
                    pending: lastClick === "PREV" ? props.pending : false,
                    icon: {
                        element: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: [
                                "far",
                                "long-arrow-alt-left"
                            ]
                        }),
                        align: "right"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var teaser_buttons = (TeaserButtons);

// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/components/_shared/teaser/teaser.module.scss
var teaser_module = __webpack_require__(35647);
var teaser_module_default = /*#__PURE__*/__webpack_require__.n(teaser_module);
;// CONCATENATED MODULE: ./src/components/_shared/teaser/teaser.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}













var Teaser = function(props) {
    var ref7, ref1, ref2;
    var ref3 = _slicedToArray((0,useWindowSize_hook/* default */.Z)(), 1), viewWidth = ref3[0];
    var ref4 = /*#__PURE__*/ react.createRef();
    var ref5 = (0,react.useState)(0), cardCount = ref5[0], setCardCount = ref5[1];
    var _initialCardIndex;
    var ref6 = (0,react.useState)((_initialCardIndex = props.initialCardIndex) !== null && _initialCardIndex !== void 0 ? _initialCardIndex : 0), currentCardIndex = ref6[0], setCurrentCardIndex = ref6[1];
    var isPrevDisabled = props.pagination ? props.pagination.page === 0 : currentCardIndex === 0;
    var isNextDisabled = props.pagination ? (props.pagination.page + 1) * props.pagination.size >= props.maxCards : currentCardIndex + cardCount >= props.maxCards;
    var onPrev = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!props.pagination) {
                            _ctx.next = 4;
                            break;
                        }
                        {
                            jumpToPage(props.pagination.page - 1);
                        }
                        _ctx.next = 14;
                        break;
                    case 4:
                        if (!ref4.current) {
                            _ctx.next = 13;
                            break;
                        }
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return (0,smooth_scrolling_helper/* smoothScroll */.l)(ref4.current.getBoundingClientRect().top);
                    case 8:
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](5);
                        console.warn(_ctx.t0);
                    case 13:
                        if (currentCardIndex >= cardCount) {
                            props.onLoadNewItems({
                                size: 4,
                                pageOrOffset: currentCardIndex - cardCount
                            });
                            setCurrentCardIndex(currentCardIndex - cardCount);
                        } else {
                            props.onLoadNewItems({
                                size: 4,
                                pageOrOffset: 0
                            });
                            setCurrentCardIndex(0);
                        }
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    10
                ]
            ]);
        }));
        return function onPrev() {
            return _ref.apply(this, arguments);
        };
    }();
    var onNext = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!props.pagination) {
                            _ctx.next = 4;
                            break;
                        }
                        {
                            jumpToPage(props.pagination.page + 1);
                        }
                        _ctx.next = 15;
                        break;
                    case 4:
                        if (!ref4.current) {
                            _ctx.next = 13;
                            break;
                        }
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return (0,smooth_scrolling_helper/* smoothScroll */.l)(ref4.current.getBoundingClientRect().top);
                    case 8:
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](5);
                        console.warn(_ctx.t0);
                    case 13:
                        props.onLoadNewItems({
                            size: 4,
                            pageOrOffset: currentCardIndex + cardCount
                        });
                        setCurrentCardIndex(currentCardIndex + cardCount);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    10
                ]
            ]);
        }));
        return function onNext() {
            return _ref.apply(this, arguments);
        };
    }();
    var jumpToPage = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(pageNumber) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!props.pagination) {
                            _ctx.next = 11;
                            break;
                        }
                        if (!ref4.current) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,smooth_scrolling_helper/* smoothScroll */.l)(ref4.current.getBoundingClientRect().top);
                    case 5:
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](2);
                        console.warn(_ctx.t0);
                    case 10:
                        props.onLoadNewItems({
                            size: props.pagination.size,
                            pageOrOffset: pageNumber
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    7
                ]
            ]);
        }));
        return function jumpToPage(pageNumber) {
            return _ref.apply(this, arguments);
        };
    }();
    var handlers = (0,react_swipeable_umd.useSwipeable)({
        onSwipedLeft: function() {
            return isNextDisabled ? undefined : onNext();
        },
        onSwipedRight: function() {
            return isPrevDisabled ? undefined : onPrev();
        }
    });
    var renderCards = function() {
        var ref;
        if (((ref = props.cards) === null || ref === void 0 ? void 0 : ref.length) > 0 && cardCount > 0) {
            var cardsToRender = props.pagination ? props.cards : props.cards.slice(0, cardCount);
            var lastRowCardCount = cardsToRender.length % cardCount > 0 ? cardsToRender.length % cardCount : cardCount;
            return _toConsumableArray(cardsToRender).concat(_toConsumableArray(Array(cardCount - lastRowCardCount).fill(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (teaser_module_default())["filler-card"]
            }))));
        } else {
            return undefined;
        }
    };
    (0,react.useEffect)(function() {
        if (props.resetOnChange) {
            setCurrentCardIndex(0);
        }
    }, [
        props.resetOnChange
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var width = (ref = ref4.current) === null || ref === void 0 ? void 0 : ref.clientWidth;
        var count;
        if (width) {
            switch(props.type){
                case basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_SMALL */.I.BASIC_CARD_SMALL:
                    count = Math.floor((width + 20) / (311 + 20));
                    break;
                case basic_card_variants_enum/* BasicCardVariants.PURCHASE_CARD_NORMAL */.I.PURCHASE_CARD_NORMAL:
                    count = Math.floor((width + 20) / (311 + 20));
                    break;
                case basic_card_variants_enum/* BasicCardVariants.CREATOKEN_CARD */.I.CREATOKEN_CARD:
                    count = Math.floor((width + 20) / (160 + 20));
                    break;
                default:
                    count = 0;
            }
            setCardCount(count);
        }
    }, [
        viewWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: props === null || props === void 0 ? void 0 : props.id,
        ref: ref4,
        "data-testid": "teaser",
        className: "".concat((teaser_module_default()).teaser, "\n            ").concat(props.pagination ? (teaser_module_default()).vertical : "", "\n            ").concat(props.inverted ? (teaser_module_default()).inverted : "", "\n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                element: props.headlineElement,
                variant: !props.headlineVariant ? typeography_variants_enum/* TypographyVariantsEnum.HEADING4_BOLD */.H.HEADING4_BOLD : props.headlineVariant,
                inverted: props.inverted,
                style: {
                    textAlign: (ref7 = props.headlineStyle) === null || ref7 === void 0 ? void 0 : (ref1 = ref7.toLowerCase) === null || ref1 === void 0 ? void 0 : ref1.call(ref7)
                },
                children: props.headline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", _objectSpread({}, handlers, {
                        className: "".concat((teaser_module_default()).content, " ").concat((teaser_module_default())[props.type]),
                        children: renderCards()
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(error_message/* ErrorMessage */.B, {
                        className: (teaser_module_default())["error-message"],
                        children: props.errorMessage
                    })
                ]
            }),
            !props.pagination || Math.floor(props.maxCards / props.pagination.size) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (teaser_module_default())["page-switch-wrapper"],
                children: [
                    props.pagination && props.withNumbers ? /*#__PURE__*/ (0,jsx_runtime.jsx)(by_page_paginator/* default */.Z, {
                        pageSize: (ref2 = props.pagination) === null || ref2 === void 0 ? void 0 : ref2.size,
                        pageNumber: props.pagination.page,
                        lastPage: Math.floor(props.maxCards / props.pagination.size),
                        totalElements: props.maxCards,
                        nextButtonDisabled: isNextDisabled,
                        prevButtonDisabled: isPrevDisabled,
                        setPageSettingsUpdate: function(pageNumber) {
                            return jumpToPage(pageNumber);
                        }
                    }) : null,
                    props.hideTeaserButtons ? undefined : /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_buttons, {
                        onClickNext: function() {
                            return onNext();
                        },
                        onClickPrev: function() {
                            return onPrev();
                        },
                        inverted: props.inverted,
                        nextButtonDisabled: isNextDisabled,
                        prevButtonDisabled: isPrevDisabled,
                        pending: props.pending
                    })
                ]
            }) : null
        ]
    });
};
Teaser.defaultProps = {
    headlineElement: "h3"
};
/* harmony default export */ var teaser = (Teaser);


/***/ }),

/***/ 53827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ smoothScroll; }
/* harmony export */ });
var HEADER_HEIGHT = 120;
var smoothScroll = function() {
    var scrollTopValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    scrollTopValue = Math.round(scrollY + scrollTopValue - HEADER_HEIGHT);
    window.scrollTo({
        top: scrollTopValue,
        behavior: "smooth"
    });
    return new Promise(function(resolve, reject) {
        var failed = setTimeout(function() {
            reject("Could not scroll to desired height");
        }, 2000);
        var scrollHandler = function() {
            if (Math.round(scrollY) === scrollTopValue) {
                window.removeEventListener("scroll", scrollHandler);
                clearTimeout(failed);
                resolve();
            }
        };
        if (scrollY === scrollTopValue) {
            clearTimeout(failed);
            resolve();
        } else {
            window.addEventListener("scroll", scrollHandler);
        }
    });
};


/***/ }),

/***/ 30407:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","by-page-paginator":"by-page-paginator_by-page-paginator__cdoVa","page-item":"by-page-paginator_page-item__nDORl","current":"by-page-paginator_current__LoUB0","previous":"by-page-paginator_previous__ADevX","next":"by-page-paginator_next__9rQ7N"};

/***/ }),

/***/ 27373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nav-buttons":"teaser-buttons_nav-buttons__4zmro","next":"teaser-buttons_next__lqB_0","previous":"teaser-buttons_previous__zWhTY"};

/***/ }),

/***/ 35647:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","teaser":"teaser_teaser__vI9fx","content":"teaser_content__l8ktC","creatoken-card":"teaser_creatoken-card__uPglt","page-switch-wrapper":"teaser_page-switch-wrapper__RvwyJ"};

/***/ })

}]);